import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { cardModalBuyTokensStyles } from './cardModalBuyTokensStyles';

export interface ICardModalBuyTokensProps {
  text?: string;
  href?: string;
  image?: string;
  subtitle?: string;
  chipText?: string;
  usPerson?: boolean;
}
export const CardModalBuyTokens = ({
  text,
  href,
  image,
  subtitle,
  chipText,
  usPerson
}: ICardModalBuyTokensProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = cardModalBuyTokensStyles(theme, isDark);

  return (
    <Grid
      item
      justifyContent='center'
      sx={classes.container}
      component={Link}
      href={href}
      target='_blank'
    >
      {/* TODO: extract to component o styled component */}
      <SvgIcon sx={classes.svgIcon} viewBox='0 0 29 24'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='100%'
          height='100%'
          viewBox='0 0 284 204.23'
        >
          <path
            d='m1,25.82C1,12.11,12.11,1,25.82,1V0C11.56,0,0,11.56,0,25.82h1Zm0,152.58V25.82H0v152.58h1Zm24.82,24.82c-13.71,0-24.82-11.11-24.82-24.82H0c0,14.26,11.56,25.82,25.82,25.82v-1Zm184.68,0H25.82v1h184.68v-1Zm24.5-23.5v-3.23h-1v3.23h1Zm0-3.23c0-11.32,9.18-20.5,20.5-20.5v-1c-11.87,0-21.5,9.63-21.5,21.5h1Zm20.5-20.5h4v-1h-4v1Zm27.5-130.18v105.68h1V25.82h-1Zm-24.82-24.82c13.71,0,24.82,11.11,24.82,24.82h1c0-14.26-11.56-25.82-25.82-25.82v1ZM25.82,1h232.35V0H25.82v1Zm233.68,155c13.53,0,24.5-10.97,24.5-24.5h-1c0,12.98-10.52,23.5-23.5,23.5v1Zm-49,48.23c13.53,0,24.5-10.97,24.5-24.5h-1c0,12.98-10.52,23.5-23.5,23.5v1Z'
            fill='#2c65c5'
          />
          <path
            d='m255.95,191.2l13.55-13.7m0,0v14m0-14h-14'
            fill='transparent'
            stroke='#2c65c5'
            strokeWidth='1px'
          />
          <foreignObject style={classes.foreignObject}>
            <Box sx={classes.countdownText}>
              <Avatar src={image} sx={classes.avatar} />
              <Typography sx={classes.title} variant='h5'>
                {text}
              </Typography>
              <Typography variant='subtitle1'>{subtitle}</Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  flexDirection: 'row'
                }}
              >
                {chipText && <Chip label={chipText} sx={classes.chip} />}
                {usPerson && (
                  <Chip
                    avatar={
                      <Avatar
                        alt='US flag'
                        src='https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/United-states_flag_icon_round.svg/2048px-United-states_flag_icon_round.svg.png'
                      />
                    }
                    label='US Person'
                    sx={classes.chipUsa}
                  />
                )}
              </Box>
            </Box>
          </foreignObject>
        </svg>
      </SvgIcon>
    </Grid>
  );
};
